import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'

export const Loading = styled(CircularProgress)`
  &.MuiCircularProgress-root {
    color: #0082ad;
  }
`
